export default class Mode{
    /**
     *
     * @param calculationType
     * @param {Number[]} numberSystems
     * @param bitCount {Number[]}
     * @param {ExerciseGenerator} exerciseGenerator
     * @param {ResultChecker} resultChecker
     * @param component
     * @param badges {String[]} i18n string resources that should be displayed with the mode
     */
    constructor(calculationType, numberSystems, bitCount, exerciseGenerator, resultChecker, component, badges){
        this.badges = badges;
        this.numberSystems = numberSystems;
        this.exerciseGenerator = exerciseGenerator;
        if(!resultChecker.prototype.check){
            throw new Error("ResultChecker did not implement check()");
        }
        this.resultChecker = resultChecker;
        this.component = component;
        this.bitCount = bitCount;
        this.calculationType = calculationType;
    }

    generateExercise = () => {
        this.exercise = new this.exerciseGenerator(this).generate();
        this.resultCheckerInstance = new this.resultChecker(this.exercise);
    };

    checkResultCorrect = (value, index) => {
        return this.resultCheckerInstance.check(value, index);
    };

    getBadges = () => {
        if(!this.badges){
            return [];
        }
        return this.badges;
    };

    getExercise = () => {
        if(!this.exercise){
            return null;
        }
        return this.exercise;
    };

    getBitCount = () => {
        return this.bitCount;
    };

    getComponent = async() => {
        return new Promise((resolve, reject)=>{
            import("../../components/modes/"+this.component).then((imported)=>{
                return resolve(imported);
            })
        })

    };

    getCalculationType = () => {
        return this.calculationType;
    };

    getNumberSystems = () => {
        return this.numberSystems;
    };

    equals = (mode) => {
        return this.exerciseGenerator === mode.exerciseGenerator &&
            this.resultChecker === mode.resultChecker &&
            this.calculationType === mode.calculationType &&
            this.numberSystems === mode.numberSystems;
    }
}